export default __webpack_public_path__ + "static/media/q9_step2_1.b7513a25.png";